import React from "react";
import { ModalStyle, ModalStyleRight } from "../Style";

const GenericModalR = ({ div, init }) => {
  return (
    <ModalStyleRight
      className="animate__animated animate__fadeIn"
      onClick={(e) => {
        e.preventDefault();
        init(null);
      }}
    >
      {div}
    </ModalStyleRight>
  );
};
export default GenericModalR;
